import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { LOGOUT_PATH, ROOT_PATH } from 'routes/paths'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { LandingPage } from './landing-page'
import { RedeemedAccess } from './redeemed'
import type { RedemptionResult } from './order-code'

export const Bookfair = () => {
  const history = useHistory()
  const { refetch } = useUserInfo()
  const [redemption, setRedemption] = useState<RedemptionResult | null>(null)

  const handleRedeemed = (result: RedemptionResult) => {
    setRedemption(result)
    refetch()
  }

  if (redemption) {
    return (
      <RedeemedAccess
        result={redemption}
        onStartReading={() => history.push(ROOT_PATH)}
        onLeave={() => history.push(LOGOUT_PATH)}
      />
    )
  }

  return <LandingPage onRedeemed={handleRedeemed} />
}
